import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

const {
	colors,
	common: { borderRadius, truncate },
	spacing: { none, sm, md, lg, xl },
	typography: { fontSizes, fontWeights },
} = THEME;

export const styleSheet = StyleSheet.create({
	card: {
		background: colors.background.light,
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		padding: `${xl}px ${lg}px`,
		gap: md,
		alignItems: 'flex-start',
		borderRadius,
		marginBottom: 'auto',
	},
	cardList: {
		gridTemplateColumns: 'repeat(auto-fill, minmax(min(320px, 100%), 1fr))',
		height: 'calc(100% - 66px)',
		gap: md,
		display: 'grid',
		paddingTop: md,
		boxSizing: 'border-box',
		overflow: 'auto',
	},
	cardName: {
		fontSize: fontSizes.lg,
		lineHeight: 1.5,
		color: colors.text.dark,
		...truncate,
		maxWidth: '100%',
		minWidth: 0,
		flex: 1,
	},
	messagePreviewText: {
		display: '-webkit-box' as any,
		WebkitLineClamp: 2,
		WebkitBoxOrient: 'vertical' as any,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'normal',
		lineHeight: 1.3,
		maxHeight: '2.6em',
	},
	grayBackground: {
		background: colors.background.main,
	},
	moreMenu: {
		position: 'absolute',
		right: md,
		top: md,
	},
	paddingTop: {
		paddingTop: lg,
	},
	statusColumn: {
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		boxSizing: 'border-box',
		gap: sm,
	},
	statusText: {
		color: colors.text.dark,
		fontSize: fontSizes.sm,
		margin: none,
	},
	successText: {
		color: colors.success.main,
		fontWeight: fontWeights.bold,
	},
	errorText: {
		color: colors.danger.dark,
		fontWeight: fontWeights.bold,
	},
	pendingText: {
		color: colors.primary.dark,
		fontWeight: fontWeights.bold,
	},
	linkText: {
		color: colors.primary.main,
		fontWeight: fontWeights.bold,
		':hover': {
			textDecoration: 'underline',
			color: colors.hover.main,
		},
	},
	rowLayout: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		overflow: 'hidden',
		boxSizing: 'border-box',
	},
	columnLayout: {
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		boxSizing: 'border-box',
	},
	tabButton: {
		alignItems: 'center',
		color: colors.text.light,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 12,
		justifyContent: 'center',
		letterSpacing: 1.05,
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
		borderRadius: 3,
		boxSizing: 'border-box',
		flexShrink: 0,
		padding: `${sm}px ${md}px`,
		background: 'transparent',
		border: 'none',
	},
	tabButtonActive: {
		alignItems: 'center',
		boxSizing: 'border-box',
		cursor: 'pointer',
		display: 'flex',
		flexShrink: 0,
		fontSize: 12,
		justifyContent: 'center',
		letterSpacing: 1.05,
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
		color: colors.primary.main,
		background: 'transparent',
		border: 'none',
		borderRadius: 3,
		padding: `${sm}px ${md}px`,
	},
});
